import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';

import { ShareInfoTypeEnum } from '../../models/enums/share-info-type.enum';
import { ShareInfoModel } from '../../models/share-info.model';
import { ShareholdersResource } from '../../services/resources/shareholders.resource';
import { TradersResource } from '../../services/resources/traders.resource';

@Component({
    selector: 'sl-share-info',
    templateUrl: './share-info.component.html',
    styleUrls: ['./share-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShareInfoComponent implements OnInit {
    id = input.required<string>();
    type = input.required<ShareInfoTypeEnum>();

    items: ShareInfoModel[] = [];
    displayedColumns: string[] = ['label', 'registeredShares', 'value'];
    valueKeyText = '';

    private readonly shareholdersResource = inject(ShareholdersResource);
    private readonly tradersResource = inject(TradersResource);

    ngOnInit(): void {
        const localItems: ShareInfoModel[] = [];

        switch (this.type()) {
            case ShareInfoTypeEnum.Shareholder:
                this.valueKeyText = 'ShareStatistics.Votes';
                this.shareholdersResource.getShareStatistics(this.id()).subscribe(r => {
                    r.value.forEach(s => {
                        localItems.push(
                            new ShareInfoModel({
                                label: s.label,
                                registeredShares: s.registeredShares,
                                value: s.votes
                            })
                        );
                    });
                    this.items = localItems;
                });
                break;
            case ShareInfoTypeEnum.Trader:
                this.valueKeyText = 'ShareStatistics.Dispo';
                this.tradersResource.getShareStatistics(this.id()).subscribe(r => {
                    r.value.forEach(s => {
                        localItems.push(
                            new ShareInfoModel({
                                label: s.label,
                                registeredShares: s.registeredShares,
                                value: s.dispoShares
                            })
                        );
                    });
                    this.items = localItems;
                });
                break;
            default:
                break;
        }
    }
}
